const PHONE_NUMBERS = {
  CUSTOMER_SERVICE: '1-888-836-3939',
  LONG_DISTANCE: '1-888-303-6927',
  MOVE_SUCCESS: '1-888-898-8139',
};

export default PHONE_NUMBERS;
